// Footer.js – Fußzeile auf allen Seiten: Leistungen, Navigation, Kontaktdaten, Rechtliches, Instagram und Link „Cookie-Einstellungen“.
import React from "react";
import { Link } from "react-router-dom";
import { oeffneCookieEinstellungen } from "./consent";
import InstagramIcon from "./components/InstagramIcon";
import betrieb, { telefonLink, mailLink, kombiniert } from "./data/betrieb";
import LogoVoll from "./components/pages/images/logo/logo-voll.webp"; // vollständiges Logo, freigestellt

const linkStyle = {
  color: "rgba(238,244,234,.55)",
  textDecoration: "none",
  transition: "color .18s",
};

function FooterLink({ to, children }) {
  return (
    <li>
      <Link
        to={to}
        style={linkStyle}
        onMouseEnter={e => (e.currentTarget.style.color = "var(--ff-grass)")}
        onMouseLeave={e => (e.currentTarget.style.color = "rgba(238,244,234,.55)")}
        onClick={() => window.scrollTo(0, 0)}
      >
        {children}
      </Link>
    </li>
  );
}

function SocialLink({ href, label, children }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      style={{ color: "rgba(238,244,234,.6)", fontSize: "1.4rem", lineHeight: 1, display: "inline-flex", transition: "color .18s" }}
      onMouseEnter={e => (e.currentTarget.style.color = "var(--ff-grass)")}
      onMouseLeave={e => (e.currentTarget.style.color = "rgba(238,244,234,.6)")}
    >
      {children}
    </a>
  );
}

function Footer() {
  const colHead = {
    fontFamily: "var(--fh)",
    fontWeight: 800,
    fontSize: "1rem",
    letterSpacing: ".1em",
    textTransform: "uppercase",
    color: "var(--ff-grass)",
    marginBottom: "1rem",
  };

  const listStyle = {
    listStyle: "none",
    padding: 0,
    margin: 0,
    fontSize: ".9rem",
    lineHeight: 2.1,
  };

  return (
    <footer
      style={{
        background: "var(--ff-black)",
        borderTop: "1px solid var(--ff-border)",
      }}
    >
      <div className="container pt-5 pb-4">
        <div className="row gy-4">

          {/* Brand */}
          <div className="col-md-4 col-sm-12">
            {/* Logo auf heller Fläche (schwarze und dunkelgrüne Teile brauchen hellen Grund); kein Überschriften-Element */}
            <div
              style={{
                display: "inline-block",
                background: "var(--ff-white)",
                borderRadius: "4px",
                padding: "10px 14px",
                marginBottom: "1rem",
              }}
            >
              <img
                src={LogoVoll}
                width={600}
                height={346}
                alt={`Logo: ${betrieb.name}, ${betrieb.rechtsname}`}
                style={{ display: "block", width: "230px", height: "auto" }}
                loading="lazy"
                decoding="async"
              />
            </div>
            <p
              style={{
                fontSize: ".9rem",
                color: "var(--ff-muted)",
                lineHeight: 1.75,
                maxWidth: "270px",
              }}
            >
              Ihr verlässlicher Partner für Forstarbeiten, Baumfällungen und
              Landschaftspflege in Schleswig-Holstein.
            </p>
          </div>

          {/* Kontakt */}
          <div className="col-md-3 col-sm-12">
            <h2 style={colHead}>Kontakt</h2>
            {/* Name, Inhaber, Anschrift, Telefon, Erreichbarkeit, E-Mail in dieser Reihenfolge und Schreibweise (src/data/betrieb.js),
                wie im Impressum und im Google-Unternehmensprofil; damit stehen die Angaben der Strukturdaten auf jeder Seite sichtbar.
                <address> ist das passende Element, Bootstrap setzt es auf normale Schrift. */}
            <address style={{ margin: 0 }}>
              <ul style={{ ...listStyle, color: "rgba(238,244,234,.6)" }}>
                <li>{betrieb.name}</li>
                <li>Inhaber: {betrieb.inhaber}</li>
                <li>{betrieb.strasse}</li>
                <li>
                  {betrieb.plz} {betrieb.ort}
                </li>
                {/* Anklickbar (Anruf/E-Mail-Programm), Optik wie die Nachbarzeilen */}
                <li>
                  <a href={telefonLink} style={{ color: "inherit", textDecoration: "none" }}>
                    {betrieb.telefon}
                  </a>
                </li>
                <li>Telefonisch: {betrieb.erreichbarkeit.kurz}</li>
                <li>
                  <a href={mailLink} style={{ color: "inherit", textDecoration: "none" }}>
                    {betrieb.email}
                  </a>
                </li>
              </ul>
            </address>
          </div>

          {/* Leistungen */}
          <div className="col-md-2 col-sm-6">
            <h2 style={colHead}>Seiten</h2>
            <ul style={listStyle}>
              <FooterLink to="/baumpflege">Baumpflege</FooterLink>
              <FooterLink to="/mulchen">Landschaftspflege</FooterLink>
              <FooterLink to="/baumfaellung">Baumfällung</FooterLink>
              <FooterLink to="/referenzen">Referenzen</FooterLink>
              <FooterLink to="/einsatzgebiet">Einsatzgebiet</FooterLink>
              <FooterLink to="/faq">Häufige Fragen</FooterLink>
              <FooterLink to="/ueber-mich">Über mich</FooterLink>
              <FooterLink to="/kontakt">Kontakt</FooterLink>
            </ul>
          </div>

          {/* Rechtliches + Social */}
          <div className="col-md-3 col-sm-6">
            <h2 style={colHead}>Rechtliches</h2>
            <ul style={{ ...listStyle, marginBottom: "1.5rem" }}>
              <FooterLink to="/impressum">Impressum</FooterLink>
              <FooterLink to="/datenschutz">Datenschutz</FooterLink>
              <li>
                <button
                  type="button"
                  onClick={oeffneCookieEinstellungen}
                  style={{ ...linkStyle, background: "none", border: 0, padding: 0, font: "inherit" }}
                  onMouseEnter={e => (e.currentTarget.style.color = "var(--ff-grass)")}
                  onMouseLeave={e => (e.currentTarget.style.color = "rgba(238,244,234,.55)")}
                >
                  Cookie-Einstellungen
                </button>
              </li>
            </ul>
            <div className="d-flex gap-3">
              <SocialLink href={betrieb.instagram} label={`${betrieb.name} auf Instagram (öffnet in neuem Fenster)`}>
                <InstagramIcon />
              </SocialLink>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div
          className="row mt-4 pt-3"
          style={{ borderTop: "1px solid var(--ff-border)" }}
        >
          <div className="col text-center">
            <p
              style={{
                fontSize: ".9rem",
                color: "rgba(238,244,234,.65)",
                margin: 0,
                letterSpacing: ".04em",
              }}
            >
              &copy; {new Date().getFullYear()} {kombiniert}. Alle Rechte vorbehalten.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
